<template>
  <modal v-if="isOpen" class-name="lieferung-modal" @close="$emit('close')">
    <template #body>
      <div>
        <p>Elektrofahrzeuge sind von der kostenlosen Lieferung auf eigener Achse ausgeschlossen und werden per Spedition auf Fremdachse für eine Gebühr von 350€ geliefert. Bei Überführung auf eigener Achse besteht eine Winterreifenpflicht bei winterlichen Straßenverhältnissen nach der Neuregelung der Straßenverkehrsordnung (StVO) seit dem 04.12.2010. Beachte, dass es bei schlechten Wetterbedingungen zu Verzögerungen bei der Auslieferung kommen kann. Alternativ kannst du Winterreifen im Online-Kauf buchen oder das Fahrzeug auf dem Anhänger liefern lassen.</p>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '../common/Modal';

export default {
  components: {
    Modal,
  },
  props: ['isOpen'],
};
</script>
<style lang="scss">
    .lieferung-modal {
        p {
            font-family: "Asap", sans-serif;
            color: #3a3a3a;
            font-size: 16px;
            font-weight: normal;
            line-height: 21px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/modals/LieferungModal.vue